export const FOOTER_PHRASES = {
    FOLLOW_US: 1884,
    ALL_RIGHTS_RESERVED: 24,
    COMPANY_INFORMATION: 11787,
    BLOG: 2141,
    BLOG_URL: 17583,
    TERMS_AND_CONDITIONS: 955,
    PRIVACY_POLICY: 20,
    SCREENING_POLICY: 3212,
    COOKIE_POLICY: 3318,
    CONTACT_US: 19,
    SUPPORT: 3221,
    SUPPORT_URL: 17593,
    DEV_SUPPORT_URL: 19702,
    ABOUT: 15952,
    CALIFORNIA_PRIVACY_POLICY: 15971,
    FAQS: 15968,
    M3INDIA_FAQS: 21857,
    HELP_CENTRE: 21445,
    HELP_CENTRE_URL: 21447,
    FAQ_URL: 17584,
    M3INDIA_FAQ_URL: 21859,
    CONTACT_US_URL: 21446,
    COPYRIGHT: 15969,
    BY: 19192,
    TWITTER: 14329,
    TWITTER_LINK: 16899,
    LINKED_IN: 20575,
    LINKED_IN_LINK: 16900,
    FACEBOOK: 20572,
    FACEBOOK_LINK: 16901,
    INSTAGRAM: 20573,
    INSTAGRAM_LINK: 16902,
    PINTEREST: 20569,
    PINTEREST_LINK: 18349,
};
